export const openAddWorkerDialogReducer = (state:any) => {
    
    state.addWorkerDialog.isOpen = true;
    state.createNewWorker.status = "idle";
    state.createNewWorker.errorMessage = "";
  }